import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Pipe, PipeTransform, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../../services/user.service';
import * as $ from 'jquery';
import { Observable } from 'rxjs';
import { MessageService } from '../../../@hornbillfx/components/message/message.service';
import { EncriptDecriptService } from '../../../services/encriptdecript';

declare var ADL: any;
declare var videojs: any;

@Component({
  selector: 'app-user-course-list',
  templateUrl: './user-course-list.component.html',
  styleUrls: ['./user-course-list.component.scss'],
  providers: [UserService],
})


export class UserCourseListComponent implements OnInit, OnDestroy {
  // video Complete Status
  vdo_val;
  categoryId: any;
  public categoryName: any;
  firstTwoLesson: any[] = [];
  sectionCount: number;
  public categoryDesc: any;
  selectedlessons;
  sum = 15;
  direction: string;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  topicsArray: any[] = [];
  topicsPaginationArray: any[] = [];
  launchUrl: string;
  xapidata: any;
  lessonResponse: any = {};
  objDomain: any;
  userobj: any;
  analytic: number;
  coursebanner: string;
  catbanner;
  imageurl: any;
  courseMapList: any[] = [];
  observablesCourseMapList: Observable<any>;
  selectedLessonToPlay: any = '';
  fullscreen: any = false;
  nextsectionStatus;
  myConfObj = {
    iframeMouseOver: false
  };

  PreLoader = true;
  public userData: any;
  treeLoader:boolean=false;
  public currentLessonStatus: any;
  @ViewChild('videoFrame') videoFrame: ElementRef;
  public courseLock: boolean;
  public courseObject: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private renderer: Renderer2, private el: ElementRef,
    private messageService: MessageService,
    private encriptDecript: EncriptDecriptService,
  ) {
    // this.activatedRoute.queryParams.subscribe((params: Params) => {
    //   this.categoryId = params['categoryId'] ? params['categoryId'] : '';
    //   this.categoryName = params['categoryName'] ? params['categoryName'] : '';
    //   this.categoryDesc = params['categoryDesc'] ? params['categoryDesc'] : '';
    //   this.analytic = params['categoryanalytic']
    //     ? params['categoryanalytic']
    //     : '';
    //   this.catbanner = params['bannerPath'] ? params['bannerPath'] : '';

    //   localStorage.comingFrom = params['categoryId']
    //     ? 'CourseVia'
    //     : 'RecentView';
    // });
    this.courseObject = this.encriptDecript.getLocalStorage('coursePageProberty');
    if (this.courseObject != '') {
      var course = JSON.parse(this.courseObject).queryParams;
      this.categoryId = course['categoryId'] ? course['categoryId'] : '';
      this.categoryName = course['categoryName'] ? course['categoryName'] : '';
      this.categoryDesc = course['categoryDesc'] ? course['categoryDesc'] : '';
      this.analytic = course['categoryanalytic']
        ? course['categoryanalytic']
        : '';
      this.catbanner = course['bannerPath'] ? course['bannerPath'] : '';
    }
    this.encriptDecript.setToLocalStorage('comingFrom', this.courseObject != ''
      ? 'CourseVia'
      : 'RecentView');
  }

  ngOnInit() {
    this.userData = this.encriptDecript.getLocalStorage('userObject');
    this.userobj = JSON.parse(this.userData);
    this.courseLock = this.userobj.roles[0].isCourseLock;
    if (this.encriptDecript.getLocalStorage('comingFrom') === 'RecentView') {
      this.getRecentViewListCourseList(this.encriptDecript.getLocalStorage('comingFromObject'));
    }
    $('.topic-list').hover(
      function () {
      },
      function (e) {
        $('.topic-list').animate({ scrollTop: 0 }, 'slow');
      }
    );
    if (this.encriptDecript.getLocalStorage('comingFrom') == 'CourseVia') {
      this.userService
        .getCategoryTreeObject(this.categoryId, this.userobj, this.courseLock)
        .subscribe(Response => {
          this.courseMapList = Response['Course']['Topics'];
          //  courseLock== true thiru 14-dec-2018
          if (this.courseLock == false) {
            for (let i = 0; i < Response['Course']['Topics'].length; i++) {
              if (Response['Course']['Topics'][i].Status === 'Unlock') {
                for (
                  let J = 0;
                  J < Response['Course']['Topics'][i].Lessons.length;
                  J++
                ) {
                  if (
                    Response['Course']['Topics'][i].Lessons[J].Status === 'Unlock'
                  ) {
                    // alert('Unlock');
                    this.playLesson(Response['Course']['Topics'][i].Lessons[J]);
                    this.currentLessonStatus = Response['Course']['Topics'][i].Lessons[J].Status;
                  }
                }
              }
            }
            const LastIndex = Response['Course']['Topics'].length - 1;
            if (Response['Course']['Topics'][LastIndex].Status === 'Completed') {
              const InnerLessonsIndex =
                Response['Course']['Topics'][LastIndex].Lessons.length - 1;
              // alert('InnerLessonsIndex');
              this.playLesson(
                Response['Course']['Topics'][LastIndex].Lessons[InnerLessonsIndex]
              );
              this.currentLessonStatus = Response['Course']['Topics'][LastIndex].Lessons[InnerLessonsIndex].Status;
            }
          } if (this.courseLock == true) {
            // alert('recordId')
            this.playLesson(Response['Course']['Topics'][0].Lessons[0]);
            this.currentLessonStatus = Response['Course']['Topics'][0].Lessons[0].Status;
          }
        });
    }
  }



  playLesson(object, fromAutoNext?) {
    // alert('playLesson');
    var previousType = this.selectedLessonToPlay.fileType;
    this.selectedLessonToPlay = Object.assign({}, object);
    if (object.Status === 'Locked') {
    } else {
      this.launchUrl = '';
      localStorage.regiId = '';
      const obj = this.userobj;
      //if it is auto next destroy previous video reference
      if (fromAutoNext) {
        if (this.lessonResponse.fileType === 'video') {
          this.destroyPreviousVideo();
        }
      }
      this.userService
        .getVideoPath(object.lessonId, obj)
        .subscribe(response => {
          this.lessonResponse = response.data;
          this.xapidata = response.xapidata;
          if (this.lessonResponse != null && this.lessonResponse !== undefined) {
            this.treeLoader=false;
            if (this.courseLock == false) {
              if (this.currentLessonStatus != 'Completed') {
                this.checkLessonIsCompletedOrNotForNormalUser();
              }
            }
            else {
              if (this.currentLessonStatus != 'Completed') {
                this.checkLessonIsCompletedOrNotForUnlockAllCourse();
              }
            }
            if (this.lessonResponse.fileType === 'zip') {
              this.launchUrl = this.xapidata.lessonLaunchURL;
            }
            else {
              localStorage.setItem(
                'restart',
                this.xapidata.isShowLaunchOptionVideo
              );
              this.launchUrl = this.xapidata.lessonLaunchURL.split('registration=')[0];
              if ($("#divVideo video")[0] != undefined) {
                $("#divVideo video")[0].load();
              }
              localStorage.setItem('regiId', this.xapidata.lessonLaunchURL.split('registration=')[1]);
              this.PreLoader = true;
              if (fromAutoNext && previousType == 'video') {
                this.reRenderTheVideo();
              }
              this.videojsConfiguration();
            }
          }
        });
    }
  }


  playSelectedLesson(object, section, index) {
    this.PreLoader = true;
    this.selectedLessonToPlay = Object.assign({}, object);
    if (section.Lessons[index + 1]) {
      this.nextsectionStatus = section.Lessons[index + 1].Status;
    }
    else {
      if (section.Lessons[index].Status == 'Unlock') {
        this.nextsectionStatus = 'Locked'
      }
      if (section.Lessons[index].Status == 'Completed' && this.courseLock == false) {
        this.nextsectionStatus = 'Completed'
      }
    }

    if (object.Status === 'Locked') {
    } else {
      this.treeLoader=true;
      this.launchUrl = '';
      localStorage.regiId = '';
      if (this.lessonResponse.fileType == 'video') {
        this.destroyPreviousVideo();
      }
      const obj = this.userobj;
      this.userService
        .getVideoPath(object.lessonId, obj)
        .subscribe(response => {
          this.lessonResponse = response.data;
          this.xapidata = response.xapidata;
          if (this.courseLock == false) {
            this.checkLessonIsCompletedOrNotForNormalUser();
          } else {
            this.checkLessonIsCompletedOrNotForUnlockAllCourse();
          }
          if (this.lessonResponse != null && this.lessonResponse !== undefined) {
            if (this.lessonResponse.fileType === 'zip') {
              this.launchUrl = this.xapidata.lessonLaunchURL
            }
            else {
              localStorage.setItem(
                'restart',
                this.xapidata.isShowLaunchOptionVideo
              );
              this.launchUrl = this.xapidata.lessonLaunchURL.split('registration=')[0];
              if ($("#divVideo video")[0] != undefined) {
                $("#divVideo video")[0].load();
              }
              localStorage.setItem('regiId', this.xapidata.lessonLaunchURL.split('registration=')[1]);
              this.onClickVideoConfiguration();
            }
          }
        });
    }
  }

  getRecentViewListCourseList(recordId) {
    this.userobj = this.userobj;
    return this.userService.getUserParam(recordId).subscribe(response => {
      this.categoryId = response.data.course.category.categoryId;
      return this.userService
        .getCategoryTreeObject(response['data']['course']['category']['categoryId'], this.userobj, this.courseLock).subscribe(
          Response => {
            this.categoryDesc = Response['Description'];
            this.categoryName = Response['CourseName'];
            this.courseMapList = Response['Course']['Topics'];
            for (let i = 0; i < Response['Course']['Topics'].length; i++) {
              if (this.courseLock === false) {
                if (Response['Course']['Topics'][i].Status === 'Unlock' || Response['Course']['Topics'][i].Status === 'Completed') {
                  for (
                    let J = 0;
                    J < Response['Course']['Topics'][i].Lessons.length;
                    J++
                  ) {
                    if (
                      Response['Course']['Topics'][i].Lessons[J].lessonId == recordId) {
                      this.playLesson(Response['Course']['Topics'][i].Lessons[J]);
                      this.currentLessonStatus = Response['Course']['Topics'][i].Lessons[J].Status;
                    }
                  }
                }
              } else {
                if (Response['Course']['Topics'][i].Status === 'Open' || Response['Course']['Topics'][i].Status === 'Completed') {
                  for (
                    let J = 0;
                    J < Response['Course']['Topics'][i].Lessons.length;
                    J++
                  ) {
                    if (
                      Response['Course']['Topics'][i].Lessons[J].lessonId == recordId
                    ) {
                      this.playLesson(Response['Course']['Topics'][i].Lessons[J]);
                      this.currentLessonStatus = Response['Course']['Topics'][i].Lessons[J].Status;
                    }

                  }
                }
              }
            }
          });
    });
  }

  getID(id) {
    return id;
  }


  videojsConfiguration() {
    setTimeout(() => {
      if (this.lessonResponse != null && this.lessonResponse !== undefined) {
        // console.log('Entrd to 1st if');
        if (this.lessonResponse.fileType === 'video') {
          // console.log('Entrd to 2nd if');
          if (ADL.XAPIWrapper.lrs.auth == null || undefined) {
            // console.log('Entrd to 3rd if');
            const credentials =
              this.xapidata.lrsUserName + ':' + this.xapidata.lrsPassword;
            this.objDomain = this.userobj;
            const orgobj = this.objDomain.organisation.domainName;
            const conf = {
              endpoint: this.xapidata.lrsEndPointURL,
              auth: 'Basic ' + btoa(credentials),
              // 12Sep2018 Constructing URL Based on Account
              actor:
                '{"objectType": "Agent","account": { "name" : "' +
                this.encriptDecript.getLocalStorage('email') +
                '","homePage": "' +
                orgobj +
                '" } ,"name":"' +
                this.encriptDecript.getLocalStorage('userName') +
                '"}'
            };

            ADL.XAPIWrapper.changeConfig(conf);
          }
          ADL.XAPIVideoJS('vid1');
          this.PreLoader = false;
        }
      }
    }, 7000);
  }

  onClickVideoConfiguration() {
    if (this.lessonResponse.fileType === 'video') {
      this.reRenderTheVideo();
    }
    // setTimeout(() => {
    if (this.lessonResponse != null && this.lessonResponse !== undefined) {
      // console.log('Entrd to 1st if');
      if (this.lessonResponse.fileType === 'video') {

        // console.log('Entrd to 2nd if');
        console.log(ADL.XAPIWrapper.lrs);
        if (ADL.XAPIWrapper.lrs.auth == null || undefined) {
          // console.log('Entrd to 3rd if');
          const credentials =
            this.xapidata.lrsUserName + ':' + this.xapidata.lrsPassword;
          this.objDomain = this.userobj;
          const orgobj = this.objDomain.organisation.domainName;
          const conf = {
            endpoint: this.xapidata.lrsEndPointURL,
            auth: 'Basic ' + btoa(credentials),
            actor:
              '{"objectType": "Agent","account": { "name" : "' +
              this.encriptDecript.getLocalStorage('email') +
              '","homePage": "' +
              orgobj +
              '" } ,"name":"' +
              this.encriptDecript.getLocalStorage('userName') +
              '"}'
          };

          console.log('in XAPIWrapper');
          ADL.XAPIWrapper.changeConfig(conf);
        }
        this.PreLoader = false;
        ADL.XAPIVideoJS('vid1');

      }
    }
    // }, 7000);
  }

  checkLessonIsCompletedOrNotForNormalUser() {
    // alert('checkLessonIsCompletedOrNotForNormalUser');
    const userObj = this.userobj;
    if (this.selectedLessonToPlay != undefined) {
      this.userService.checkIsLessonCompleted(this.selectedLessonToPlay.lessonId, userObj)
        .subscribe(response => {
          if (response.data.status == 'Completed' && this.router.url.split('?')[0] == '/user/course/browse') {
            if (this.nextsectionStatus) {
              if (this.nextsectionStatus == 'Locked' && this.courseLock == false) {
                this.getLatestCourseMapStatus().then(() => this.onClickNextSection());
              }
            }
            else {
              this.getLatestCourseMapStatus().then(() => this.onClickNextSection());
            }
          }
          else {
            if (this.router.url.split('?')[0] == '/user/course/browse') {
              setTimeout(() => {
                this.checkLessonIsCompletedOrNotForNormalUser();
              }, 5000);
            }
          }
        })
    }
  }

  checkLessonIsCompletedOrNotForUnlockAllCourse() {
    // alert('checkLessonIsCompletedOrNotForUnlockAllCourse');
    const userObj = this.userobj;
    if (this.selectedLessonToPlay != undefined) {
      this.userService.checkIsLessonCompleted(this.selectedLessonToPlay.lessonId, userObj)
        .subscribe(response => {
          if (response.data.status == 'Completed' && this.router.url.split('?')[0] == '/user/course/browse') {
            if (this.nextsectionStatus) {
              if (this.nextsectionStatus == 'Open') {
                this.getLatestCourseMapStatus();
              }
            }
            else {
              if (this.courseLock == true) {
                this.getLatestCourseMapStatus();
              }
            }
          }
          else {
            if (this.router.url.split('?')[0] == '/user/course/browse') {
              setTimeout(() => {
                this.checkLessonIsCompletedOrNotForUnlockAllCourse();
              }, 5000);
            }
          }
        })
    }
  }


  /**
   * @description - async method  to call  the course list to get the latest course list with updated status.
   * */
  public async getLatestCourseMapStatus() {
    return await new Promise<any>((resolve, reject) => {
      this.getCourseMapList((cb) => {
        if (cb) {
          resolve(true);
        }
      });
    });
  }


  public onClickFullScreen() {
    if (this.videoFrame.nativeElement) {
      if (this.videoFrame.nativeElement.requestFullscreen) {
        this.fullscreen = true;
        this.videoFrame.nativeElement.requestFullscreen();
      } else if (this.videoFrame.nativeElement.mozRequestFullScreen) {
        /* Firefox */
        this.fullscreen = true;
        this.videoFrame.nativeElement.mozRequestFullScreen();
      } else if (this.videoFrame.nativeElement.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.fullscreen = true;
        this.videoFrame.nativeElement.webkitRequestFullscreen();
      } else if (this.videoFrame.nativeElement.msRequestFullscreen) {
        /* IE/Edge */
        this.fullscreen = true;
        this.videoFrame.nativeElement.msRequestFullscreen();
      }
    }
  }

  public closeNav() {
    if (this.videoFrame.nativeElement) {
      if (this.videoFrame.nativeElement.exitFullscreen) {
        this.fullscreen = true;
        this.videoFrame.nativeElement.exitFullscreen();
      } else if (this.videoFrame.nativeElement.mozCancelFullScreen) {
        /* Firefox */
        this.fullscreen = true;
        this.videoFrame.nativeElement.mozCancelFullScreen();
      } else if (this.videoFrame.nativeElement.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.fullscreen = true;
        this.videoFrame.nativeElement.webkitExitFullscreen();
      } else if (this.videoFrame.nativeElement.msExitFullscreen) {
        /* IE/Edge */
        this.fullscreen = true;
        this.videoFrame.nativeElement.msExitFullscreen();
      }
    }
  }

  /**
   * @description - Method to get the updated latest Course Map tree list.
   * This method gets the list with updated status of the sections.
   */
  public getCourseMapList(cb) {
    setTimeout(() => {
      let latestData;
      this.observablesCourseMapList = this.userService.getCourseList(this.categoryId, this.userobj, this.courseLock);
      this.observablesCourseMapList.subscribe(
        (data => {
          latestData = [...data];
          cb(true);
        }),
        (error) => {
        },
        () => {
          this.courseMapList = JSON.parse(JSON.stringify([...latestData]));
        }
      );
    }, 3000);
  }

  public onClickNextSection() {
    const currentLesson = Object.assign({}, this.selectedLessonToPlay);
    let latestLessonPlayed: any;
    if (currentLesson.Status === 'Completed') {
      this.moveNextSection();
    } else {
      this.getLatestLessionStatus((data: any[]) => {
        if (data) {
          this.courseMapList = data;
          for (let topicIndex = 0; topicIndex < data.length; topicIndex++) {
            for (let lessonIndex = 0; lessonIndex < data[topicIndex].Lessons.length; lessonIndex++) {
              if (data[topicIndex].Lessons[lessonIndex].lessonId === currentLesson.lessonId) {
                latestLessonPlayed = data[topicIndex].Lessons[lessonIndex];
              }
            }
          }
          if (latestLessonPlayed && latestLessonPlayed.Status === 'Completed') {
            this.moveNextSection();
          } else {
            if (this.courseLock == false) {
              this.checkLessonIsCompletedOrNotForNormalUser();
            } else {
              this.checkLessonIsCompletedOrNotForUnlockAllCourse();
            }
            alert('Complete the previous section');
            return false;
          }
        }
      });
    }
  }

  moveNextSection() {
    const currentLesson = Object.assign({}, this.selectedLessonToPlay);
    for (let i = 0; i < this.courseMapList.length; i++) {
      for (let j = 0; j < this.courseMapList[i].Lessons.length; j++) {
        if (this.courseMapList[i].Lessons[j].lessonId === currentLesson.lessonId) {
          if (this.courseMapList[i].Lessons[j + 1]) {
            if (this.courseMapList[i].Lessons[j + 1].Status != 'Completed') {
              this.playLesson(this.courseMapList[i].Lessons[j + 1], true);
            }
            return false;
          } else if (!((i + 1) - this.courseMapList.length === 0) && this.courseMapList[i + 1]) {
            // moving to next Topic first section(lesson).
            this.playLesson(this.courseMapList[i + 1].Lessons[0], true);
            return false;
          } else {
            // console.log('End of the course!');
            break;
          }
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.lessonResponse != null && this.lessonResponse !== undefined) {
      if (this.lessonResponse.fileType === 'video') {
        this.destroy();
        ADL.XAPIWrapper.lrs.auth = null;
      }
    }
  }

  destroy() {
    if (this.lessonResponse.fileType === 'video') {
      if (document.getElementById('vid1') != null) {
        const video = videojs('vid1');
        const change = video;

        const before_load = video.dispose();

        $(document).on('turbolinks:load', change);
        $(document).on('turbolinks:before-visit', before_load);

      }
    }
  }
  destroyPreviousVideo() {
    if (this.lessonResponse != null && this.lessonResponse !== undefined) {
      if (this.lessonResponse.fileType === 'video') {
        this.destroyVideo();
        ADL.XAPIWrapper.lrs.auth = null;
      }
    }
  }

  destroyVideo() {
    if (this.lessonResponse.fileType === 'video') {
      if (document.getElementById('vid1') != null) {
        const video = videojs('vid1');
        const change = video;

        const before_load = video.dispose();

        $(document).on('turbolinks:load', change);
        $(document).on('turbolinks:before-visit', before_load);
      }
    }
  }
  reRenderTheVideo() {
    var videoDiv = document.getElementById('divVideo');
    if (videoDiv != null) {
      var video = document.createElement('video');
      var source = document.createElement('source');
      video.id = 'vid1';
      video.className = 'video-js vjs-default-skin  embed-responsive-item  vjs-big-play-centered';
      video.setAttribute('controls', 'controls');
      source.setAttribute('src', this.launchUrl);
      source.setAttribute('type', 'video/mp4');
      source.setAttribute('id', 'example');
      video.appendChild(source);
      videoDiv.appendChild(video);
    }

  }

  resetVideo() {
    if (document.getElementById('vid1') != null) {
    }
  }

  private getLatestLessionStatus(cb) {
    this.userService
      .getCategoryTreeObject(this.categoryId, this.userobj, this.courseLock)
      .subscribe(Response => {
        cb(Response['Course']['Topics']);
      });
  }
}

// pipe
@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-course/user-course-list/user-course-list.component.ts